import React from "react";
import { useFormContext } from "react-hook-form";
import { PrimaryButton } from "../../atoms/Buttons";
import { P } from "../../atoms/Texts";
import { TaxDetailsFields } from "../../molecules/Forms/Fields";
import { FormBuilder } from "../../molecules/Forms/FormBuilder";

const FormTwo = ({ onCreateOrganization }) => {
  const formCtx = useFormContext();
  const { handleSubmit } = formCtx;

  const submitForm = (data) => {
    onCreateOrganization(data);
  };

  return (
    <div className="pb-40">
      <form onSubmit={handleSubmit(submitForm)} className="pb-10">
        <div
          className="rounded-sm flex items-center justify-center text-center mb-6"
          style={{ backgroundColor: "#FFF4E5", height: "72px" }}
        >
          <P color="#663C02" className="pl-3 font-medium text-center">
            This section is optional, but gives your organization more credibility.
          </P>
        </div>
        <section className="grid grid-cols-1 md:grid-cols-2 gap-x-5 gap-y-6 mb-10">
          <FormBuilder key="basic-input" fields={TaxDetailsFields} />
        </section>
        <PrimaryButton>Create Organization</PrimaryButton>
      </form>
    </div>
  );
};

export default FormTwo;
